var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.003 4C9.79305 4 8.00151 5.79086 8.00151 8C8.00151 9.06087 8.42309 10.0783 9.17352 10.8284C9.92395 11.5786 10.9418 12 12.003 12C14.213 12 16.0045 10.2091 16.0045 8C16.0045 5.79086 14.213 4 12.003 4ZM18.4555 15.66L19.896 18.55C20.052 18.8595 20.0366 19.2277 19.8552 19.5231C19.6739 19.8185 19.3524 19.999 19.0057 20H5.00037C4.65365 19.999 4.33219 19.8185 4.15081 19.5231C3.96944 19.2277 3.95401 18.8595 4.11004 18.55L5.55058 15.66C6.05957 14.6408 7.10207 13.9978 8.2416 14H15.7644C16.904 13.9978 17.9465 14.6408 18.4555 15.66Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user.2e04aefe.svg";
export { ForwardRef as ReactComponent };